import { Injectable, inject } from "@angular/core";

import { ApiService } from "@tylertech/core-module";
import
{
    ClassMetadata,
    DocumentSearchCriteria,
    GridMetadata,
    IVendorInvoiceEntryService,
} from "@tylertech/tyler-api-types";


/**
 * TODO - This should be generated with the ExpressService attribute in Tyler.Api
 */
@Injectable()
export class VendorInvoiceEntryService<TInvoice = unknown, TPurchaseOrder = unknown> implements IVendorInvoiceEntryService<TInvoice, TPurchaseOrder>
{
    private readonly $apiService = inject(ApiService);


    CreateInvoice(pPurchaseOrderId: string): Promise<TInvoice>
    {
        return this.$apiService.sendAuth("IVendorInvoiceEntryService/CreateInvoice", pPurchaseOrderId);
    }

    GetDocumentSearchCriteria(invoice: TInvoice): Promise<DocumentSearchCriteria>
    {
        return this.$apiService.sendAuth("IVendorInvoiceEntryService/GetDocumentSearchCriteria", invoice);
    }

    GetInvoiceItemMetadata(): Promise<GridMetadata>
    {
        return this.$apiService.sendAuth("IVendorInvoiceEntryService/GetInvoiceItemMetadata");
    }

    GetInvoiceMetadata(): Promise<ClassMetadata>
    {
        return this.$apiService.sendAuth("IVendorInvoiceEntryService/GetInvoiceMetadata");
    }

    GetPurchaseOrders(filterString: string): Promise<TPurchaseOrder[]>
    {
        return this.$apiService.sendAuth("IVendorInvoiceEntryService/GetPurchaseOrders", null, filterString);
    }

    SaveInvoice(invoice: TInvoice): Promise<void>
    {
        return this.$apiService.sendAuth("IVendorInvoiceEntryService/SaveInvoice", invoice);
    }
}
